/* Site-wide smooth scrolling (Lenis). Desktop mouse/trackpad only. Drawers, menus, modals and any
   scrollable element keep native scrolling; Lenis pauses whenever the theme locks page scroll. */
(() => {
  const start = () => {
    if (!window.Lenis || window.icLenis) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (matchMedia('(hover: none)').matches || matchMedia('(pointer: coarse)').matches) return;

    const NATIVE = 'cart-drawer, .drawer, .menu-drawer, .burger-menu, details-modal, .search-modal, predictive-search, ' +
      'quick-add-modal, .quick-add-modal, modal-dialog, [role="dialog"], [aria-modal="true"], .modal, .popup, ' +
      '.facets, .mobile-facets, [data-lenis-prevent]';
    const lenis = new Lenis({
      lerp: 0.15,
      autoRaf: true,
      allowNestedScroll: true,
      anchors: true,
      prevent: node => !!(node.closest && node.closest(NATIVE)),
    });
    window.icLenis = lenis;

    // Pause while the theme locks page scroll (cart drawer, menus, search, popups)
    const locked = () =>
      /overflow-hidden|scroll-lock|no-scroll|modal-open/.test(document.body.className) ||
      [document.documentElement, document.body].some(el => {
        if (el.classList.contains('lenis-stopped')) return false;
        const cs = getComputedStyle(el);
        return cs.overflowY === 'hidden' || cs.overflow === 'hidden';
      });
    const sync = () => (locked() ? lenis.stop() : lenis.start());
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    sync();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
